import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import {Button, Spin} from 'antd';
import classNames from 'classnames';

import {ENUM_PAYMENT_PAYMENTSTATUS} from '../../__generated__/global-types';
import {INDEX, toOrderId} from '../../config/routes';
import {payment, paymentVariables} from '../../shared/graphql/__generated__/payment';
import {QUERY_PAYMENT} from '../../shared/graphql/payment';

import cls from './Order.module.scss'

const POLLING_INTERVAL = 5000;

export const PaymentCheck: React.FC = () => {
    const {id} = useParams<{id: string}>();
    const navigate = useNavigate();
    const [statusError, setStatusError] = useState<string | null>(null);
    const pollerRef = useRef<ReturnType<typeof setInterval> | null>(null);

    const {data, loading, error, refetch} = useQuery<payment,paymentVariables>(QUERY_PAYMENT, {
        variables: {documentId: id!},
        skip: !id,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    });

    const stopPolling = useCallback(() => {
        if (pollerRef.current) {
            clearInterval(pollerRef.current);
            pollerRef.current = null;
        }
    }, []);

    useEffect(() => {
        if (!id) {
            return undefined;
        }

        pollerRef.current = setInterval(() => {
            refetch();
        }, POLLING_INTERVAL);

        return () => {
            stopPolling();
        };
    }, [id, refetch, stopPolling]);

    const paymentStatus = data?.payment?.paymentStatus;
    const orderDocumentId = data?.payment?.order?.documentId;

    useEffect(() => {
        if (!paymentStatus) {
            return;
        }

        if (paymentStatus === ENUM_PAYMENT_PAYMENTSTATUS.PAID_2 && orderDocumentId) {
            stopPolling();
            navigate(toOrderId(orderDocumentId));
        } else if (ENUM_PAYMENT_PAYMENTSTATUS.CANCELLED_3 || ENUM_PAYMENT_PAYMENTSTATUS.ERROR_5) {
            stopPolling();
            setStatusError('Оплата не прошла. Попробуйте еще раз.');
        } else if (ENUM_PAYMENT_PAYMENTSTATUS.REFUND_4) {
            stopPolling();
            setStatusError('Был произведен возврат платежа.');
        }
    }, [paymentStatus, orderDocumentId, navigate, stopPolling]);

    const handleClose = () => {
        if (orderDocumentId) {
            navigate(toOrderId(orderDocumentId));
        } else {
            navigate(INDEX);
        }
    };

    if (!id) {
        return (
            <div className={classNames(['half', cls.payment])}>
                <h1>Ошибка оплаты</h1>
                <p>Некорректный идентификатор платежа.</p>
                <Button type="primary" onClick={() => navigate(INDEX)}>На главную</Button>
            </div>
        );
    }

    if (error || statusError || (!loading && !data?.payment)) {
        return (
            <div className={classNames(['half', cls.payment])}>
                <h1>Ошибка оплаты</h1>
                <p>{statusError || 'Не удалось получить информацию о платеже. Попробуйте позже.'}</p>
                <Button type="primary" onClick={handleClose}>{orderDocumentId ? 'Назад в заказ' : 'Хорошо'}</Button>
            </div>
        );
    }

    return (
        <div className={classNames(['half', cls.payment])}>
            <Spin size="large"/>
            <h2>Проверяем оплату</h2>
            <p>Это может занять несколько секунд...</p>
        </div>
    );
};


